import api from "../../_core/api";
import { CreatePartnerUserParams, GetPartnerUsersParams, GetPartnerUsersResp, PartnerAdmin } from "./types";

export const getPartnerUsers = async (parameters: GetPartnerUsersParams): Promise<GetPartnerUsersResp> => {
  const { data }: { data: GetPartnerUsersResp } = await api({
    method: "GET",
    url: "/users",
    params: parameters,
  });
  return data;
};

export const createPartnerUser = async (parameters: CreatePartnerUserParams): Promise<string> => {
  const { data }: { data: string } = await api({
    method: "POST", 
    url: "/users",
    data: parameters,
  });
  return data;
};

export const deletePartnerUser = async (userId: string): Promise<void> => {
  await api({
    method: "DELETE",
    url: `/users/${userId}`,
  });
};

export const removePartnerUserEmailSuppression = async (userId: string): Promise<void> => {
  await api({
    method: "DELETE",
    url: `/users/${userId}/email-suppression`,
  });
};

export const resendPartnerUserWelcomeEmail = async (userId: string): Promise<void> => {
  await api({
    method: "POST",
    url: `/users/${userId}/resend-email`,
  });
};

export const getPartnerAdminStatus = async (): Promise<PartnerAdmin> => {
  const { data }: { data: boolean } = await api({
    method: "GET",
    url: "/users/my/admin",
  });
  return { isAdmin: data };
};